import { useState } from "react";
import { opinionGroups } from "@/mocks/homeData";
import SectionHeading from "./SectionHeading";

export default function OpinionSection() {
  const [activeKey, setActiveKey] = useState(opinionGroups[0].key);
  const activeGroup = opinionGroups.find((group) => group.key === activeKey) ?? opinionGroups[0];

  return (
    <section id="opinion" className="scroll-mt-20 border-b border-background-300/70 bg-background-50">
      <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-14">
        <SectionHeading
          eyebrow="COMMENTS"
          title="评论区观点聚合：不同立场分别摆开"
          desc="同一件事，蝌蚪黑料评论区往往能同时出现好几种声音。这里按立场分组收纳，切换标签就能对比着看。"
        />

        <div className="mb-6 inline-flex flex-wrap gap-1 rounded-full bg-background-200 p-1">
          {opinionGroups.map((group) => (
            <button
              key={group.key}
              type="button"
              onClick={() => setActiveKey(group.key)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 font-label text-sm transition-colors ${
                activeKey === group.key
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:text-primary-700"
              }`}
            >
              {group.label}
            </button>
          ))}
        </div>

        <p className="mb-5 flex items-center gap-2 font-label text-xs text-foreground-500">
          <span className="flex h-4 w-4 items-center justify-center text-accent-600">
            <i className="ri-price-tag-3-line text-sm"></i>
          </span>
          当前分组：{activeGroup.hint}
        </p>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
          {activeGroup.items.map((item) => (
            <article
              key={item.name}
              className="flex flex-col rounded-lg border border-background-300/70 bg-background-100 p-4 md:p-5"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-secondary-200 font-heading text-sm font-bold text-secondary-900">
                  {item.name.slice(0, 1)}
                </span>
                <div className="min-w-0">
                  <p className="truncate font-label text-sm font-medium text-foreground-900">{item.name}</p>
                  <p className="truncate font-label text-xs text-foreground-500">{item.role}</p>
                </div>
                <span className="ml-auto shrink-0 rounded bg-accent-100 px-2 py-0.5 font-label text-xs text-accent-900">
                  {item.stance}
                </span>
              </div>
              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">{item.text}</p>
              <div className="mt-4 flex items-center gap-4 border-t border-background-300/60 pt-3 font-label text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-thumb-up-line text-xs"></i>
                  </span>
                  认同
                </span>
                <span className="flex items-center gap-1">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-chat-3-line text-xs"></i>
                  </span>
                  回复
                </span>
                <span className="ml-auto flex items-center gap-1">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-share-forward-line text-xs"></i>
                  </span>
                  转发
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}